import React from "react";
import { string } from "prop-types";
import "./speaker-name.m.css";

export const SpeakerName = ({ children }) => {
  return (
    <div styleName="speaker-name">
      {children}
    </div>
  );
};

SpeakerName.propTypes = {
  children: string.isRequired,
};